import { axiosInstance } from "./config";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useTenderQuestionsAndAnswers = (tenderId: number) => {
  return useQuery({
    queryKey: ["q&a", tenderId],
    queryFn: () => axiosInstance.get(`tender-questions/${tenderId}`),
  });
};

export const useTenderCreateQuestion = (tenderId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (question: string) =>
      axiosInstance.post(`tender-questions/${tenderId}`, { question }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["q&a", tenderId] });
    },
  });
};

export const useQuotationQuestionsAndAnswers = (quotationId: number) => {
  return useQuery({
    queryKey: ["quotation-q&a", quotationId],
    queryFn: () => axiosInstance.get(`quotation-questions/${quotationId}`),
  });
};

export const useQuotationCreateQuestion = (quotationId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (question: string) =>
      axiosInstance.post(`quotation-questions/${quotationId}`, { question }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["quotation-q&a", quotationId],
      });
    },
  });
};
